import React from 'react'
import { SelectFromObject } from '../../../global/components/forms/index.js'

const rowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '16px',
  width: '100%',
  alignItems: 'center',
}

const labelColStyle = {
  width: '50%',
  marginBottom: '16px',
}

const inputColStyle = {
  width: '50%',
}

export const RequestFilesFolderSelection = ({
  workspaceList,
  client,
  clientId,
  _personal,
  handleClientChange,
}) => {
  return (
    <div style={{ width: '100%' }}>
      <div style={rowStyle}>
        <div style={labelColStyle}>
          <p>
            <strong>Workspace</strong>
          </p>
          <p>Select workspace to request from</p>
        </div>

        <div style={inputColStyle}>
          {workspaceList ? (
            <SelectFromObject
              change={handleClientChange}
              items={workspaceList}
              disabled={!!client}
              display="name"
              displayStartCase={false}
              filterable={true}
              isClearable={true}
              name="clientId"
              placeholder="Upload to general files"
              selected={clientId || _personal}
              value="_id"
            />
          ) : (
            <small>
              <strong>Note:</strong> You do not have any client workspaces.
              Files will upload to General Files.
            </small>
          )}
        </div>
      </div>
    </div>
  )
}
